import { render } from "./CategoryMostPurchased.vue?vue&type=template&id=5522e8d1&scoped=true"
import script from "./CategoryMostPurchased.vue?vue&type=script&lang=js"
export * from "./CategoryMostPurchased.vue?vue&type=script&lang=js"

import "./CategoryMostPurchased.vue?vue&type=style&index=0&id=5522e8d1&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5522e8d1"]])

export default __exports__